// extracted by mini-css-extract-plugin
export default {"confirmWrapper":"confirmationBox_confirmWrapper__tjyxd"};